import {
  ActionError,
  DeliveryDates,
  DeliveryDatesRequest,
} from '@dgx-pr-spa/shared/util';
import { createAction, props } from '@ngrx/store';

export const loadDeliveryDates = createAction(
  '[Product Details] Load Replacement Delivery Dates',
  props<{ payload?: DeliveryDatesRequest }>()
);

export const loadDeliveryDatesSuccess = createAction(
  '[Product Details] Load Replacement Delivery Dates Success',
  props<{ payload: DeliveryDates }>()
);

export const loadDeliveryDatesFail = createAction(
  '[Product Details] Load Replacement Delivery Dates Fail',
  props<ActionError>()
);

export const resetDeliveryDates = createAction(
  '[Product Details] Reset Replacement Delivery Dates'
);

export const handleDeliveryApiError = createAction(
  '[Product Details] Handle Replacement Delivery Unavailable',
  props<{ payload: DeliveryDates }>()
);

export const triggerDeliveryApiError = createAction(
  '[Product Details] Trigger Replacement Delivery Unavailable',
  props<{ payload: DeliveryDates }>()
);

export type DeliveryDatesActions =
  | typeof loadDeliveryDates
  | typeof loadDeliveryDatesSuccess
  | typeof loadDeliveryDatesFail
  | typeof resetDeliveryDates
  | typeof handleDeliveryApiError
  | typeof triggerDeliveryApiError;
